/* Daza Organic · «Qué lleva»: un ingrediente activo a la vez, cambia cada
   5s en ciclo continuo (mismo criterio que el carrusel de «por qué
   funciona»: hover/foco pausa, prefers-reduced-motion lo desactiva). La
   descripción de cada activo vive DENTRO de su propio chip como un
   desplegable (ver daza-ficha.css): el CSS reacciona solo a la clase
   .is-activa, así que este script no necesita saber nada de eso. */
(function () {
  'use strict';

  function definir() {
    if (customElements.get('daza-activos-ciclo')) return;

    customElements.define('daza-activos-ciclo', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.listo) return;
        this.dataset.listo = '1';

        var items = [].slice.call(this.querySelectorAll(':scope > ul > li'));
        if (items.length < 2) return;

        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
        var activo = 0;
        var timer = null;

        function marcar(i) {
          activo = i;
          items.forEach(function (li, idx) {
            li.classList.toggle('is-activa', idx === activo);
          });
        }
        function iniciar() {
          if (timer || reduce.matches) return;
          timer = setInterval(function () {
            marcar((activo + 1) % items.length);
          }, 5000);
        }
        function detener() {
          clearInterval(timer);
          timer = null;
        }

        iniciar();

        items.forEach(function (li, idx) {
          li.addEventListener('mouseenter', function () { detener(); marcar(idx); });
          li.addEventListener('mouseleave', iniciar);
          li.addEventListener('focusin', function () { detener(); marcar(idx); });
          li.addEventListener('focusout', iniciar);
        });
      }
    });
  }

  definir();
  document.addEventListener('shopify:section:load', definir);
})();
